import alarmMana from './alarmMana'

const zhCN = { alarmMana: alarmMana.zhCN }
const enUS = { alarmMana: alarmMana.enUS }
export default { zhCN, enUS }